/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ForgotPasswordRequestModel } from '../../models/forgot-password-request-model';

export interface LocalAccountForgotPasswordRequestPost$Params {
  
    /**
     * Forgot password request model containing email address
     */
    body?: ForgotPasswordRequestModel
}

export function localAccountForgotPasswordRequestPost(http: HttpClient, rootUrl: string, params?: LocalAccountForgotPasswordRequestPost$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, localAccountForgotPasswordRequestPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as AuthenticationStrictHttpResponse<void>;
    })
  );
}

localAccountForgotPasswordRequestPost.PATH = '/LocalAccount/ForgotPasswordRequest';
